import { salesGet, salesPatch, salesPost } from './salesTeam';
import type { JobSiteType } from './partnerJobs';

/** A Sales Partner's saved customers (Api: routes/admin/partner-customers.ts). The page offers what the Api's
 * permission strings allow: customers:write for the partner's team, customers:read for its rep, manager and EVI. */
export type CustomerRole = 'property_manager' | 'building_admin' | 'charger_owner';
export const CUSTOMER_ROLE_LABELS: Record<CustomerRole, string> = { property_manager: 'Property manager', building_admin: 'Building admin', charger_owner: 'Charger owner' };
export const CUSTOMER_ROLES = Object.keys(CUSTOMER_ROLE_LABELS) as CustomerRole[];

export interface CustomerSite {
  id?: string; label: string; street: string; city: string; state: string; zip: string; country: string;
  google_place_id?: string; coordinates?: { lat: number; lng: number } | null; site_type: JobSiteType | null;
}
export interface PartnerCustomer {
  id: string; agent_id: string; partner_name: string | null;
  business_name: string; contact_name: string; contact_email: string; contact_phone: string;
  customer_role: CustomerRole | null; sites: Array<CustomerSite & { id: string }>; notes: string;
  created_by: string; created_at: string; updated_at: string; archived: boolean;
}
export interface CustomerViewer { kind: string; permissions: string[] }
export interface CustomerInput {
  business_name: string; contact_name: string; contact_email: string; contact_phone: string;
  customer_role: CustomerRole | null; sites: CustomerSite[]; notes: string;
}
export interface CustomerJob { id: string; status: string; site_id: string | null; address: string; chargers: number; created_at: string }

export const listCustomers = (params: { q?: string; archived?: boolean } = {}) => {
  const qs = new URLSearchParams();
  if (params.q) qs.set('q', params.q);
  if (params.archived) qs.set('archived', 'true');
  return salesGet<{ viewer: CustomerViewer; customers: PartnerCustomer[] }>(`admin/partner-customers${qs.size ? `?${qs}` : ''}`);
};
export const getCustomer = (id: string) => salesGet<{ viewer: CustomerViewer; customer: PartnerCustomer; jobs: CustomerJob[] }>(`admin/partner-customers/${id}`);
export const createCustomer = (body: CustomerInput) => salesPost<PartnerCustomer>('admin/partner-customers', body);
export const updateCustomer = (id: string, body: Partial<CustomerInput>) => salesPatch<PartnerCustomer>(`admin/partner-customers/${id}`, body);
export const archiveCustomer = (id: string, archived: boolean) => salesPost<PartnerCustomer>(`admin/partner-customers/${id}/${archived ? 'archive' : 'restore'}`, {});

export const blankSite = (country = 'US'): CustomerSite => ({ label: '', street: '', city: '', state: '', zip: '', country, site_type: null });
export const siteLine = (s: Pick<CustomerSite, 'label' | 'street' | 'city' | 'state'>) => [s.label, [s.street, s.city, s.state].filter(Boolean).join(', ')].filter(Boolean).join(' · ');
